export enum OrganizationPageTabs {
  Allmänt = "uppgifter",
  Users = "användare",
  Vehicles = "fordon",
  Naturvardsverket = "naturvårdsverket",
  Api = "api",
  Rättigheter = "rättigheter",
}
